import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import {Link, animateScroll as scroll} from 'react-scroll';
import ABTest, {DebugMenu} from 'react-controlled-ab';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import classNames from 'classnames';
import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent';

export default function ModalExitSales({version = 'full', ...props}) {
  const {isOpen, toggle} = useExitIntent(60000);

  return (
    <Modal className="modal-exit-intent modal-exit-intent-empowerment" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          {version === 'sales297' ? (
            <>
              <h4 className="section-heading">
                Don’t miss out! <br className="d-none d-lg-block d-xl-none" />
                You'll only get <br className="d-none d-sm-block d-lg-none" />
                this special offer here.
              </h4>
              <p>
                Own <em>Healthy Heart,</em> the life-
                <br className="d-none d-lg-block d-xl-none" />
                changing course, <br className="d-none d-sm-block d-lg-none d-xl-block" />
                for only $297 <br className="d-none d-lg-block d-xl-none" />—{' '}
                <strong>50% off the regular price!</strong>
              </p>
            </>
          ) : version === 'salesDay' ? (
            <>
              <h4 className="section-heading">Last day to get this great deal!</h4>
              <p>
                Own <em>Healthy Heart,</em> the life-changing course, for only $297 — a <strong>$200 savings</strong>{' '}
                off the regular price.
              </p>
              <h5 className="mt-0">You won’t get this price again.</h5>
            </>
          ) : (
            <>
              <h4 className="section-heading">
                Take control of <br className="d-none d-lg-block" />
                your heart health.
              </h4>
              <p>
                Get unlimited access to the <br className="d-none d-lg-block d-xl-none" />
                <em>Healthy Heart</em> course <br className="d-none d-sm-block d-lg-none" />– including recipes,
                support, and the latest information on heart health that even your doctor may not know about yet – for
                just $497.
              </p>
            </>
          )}

          <Button
            className="btn-exit text-uppercase text-white text-h5"
            color="cta"
            onClick={toggle}
            block
            activeClass="active"
            spy={true}
            offset={-55}
            to="hbc-join-cta-1"
            smooth={true}
            href="#"
            tag={Link}
          >
            {version === 'salesDay' || version === 'sales497' ? (
              <>
                BUY{' '}
                <em>
                  Healthy <br className="d-none d-lg-block d-xl-none" />
                  Heart
                </em>{' '}
                NOW
              </>
            ) : (
              <>
                Invest in your <br className="d-none d-sm-block" />
                heart health NOW
              </>
            )}
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div
            className={classNames(
              `exit-modal-image background-image-${
                version === 'sales297' ? '1248256421' : version === 'salesDay' ? '1181408097' : '1297543648'
              }`
            )}
          />
        </Col>
      </Row>
    </Modal>
  );
}
